<template>
  <div v-if="S_USER_PROFILE" id="user-profile">
    <profile-header :header-data="S_USER_PROFILE" />
  </div>
</template>

<script>
// import { BRow, BCol } from "bootstrap-vue";
import ProfileHeader from "./ProfileHeader.vue";
// import ProfileAbout from "./ProfileAbout.vue";
// import ProfileSuggestedPages from "./ProfileSuggestedPages.vue";
// import ProfileTwitterFeed from "./ProfileTwitterFeed.vue";
// import ProfilePost from "./ProfilePost.vue";
// import ProfileLatestPhotos from "./ProfileLatestPhotos.vue";
// import ProfileSuggestion from "./ProfileSuggestion.vue";
// import ProfilePolls from "./ProfilePolls.vue";
// import profileBottom from "./profileBottom.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    // BRow,
    // BCol,
    ProfileHeader,
    // ProfileAbout,
    // ProfileSuggestedPages,
    // ProfileTwitterFeed,
    // ProfilePost,
    // ProfileLatestPhotos,
    // ProfileSuggestion,
    // ProfilePolls,
    // profileBottom,
  },
  data() {
    return {
      profileData: {},
    };
  },
  methods: {
    ...mapActions({
      A_GET_USER_PROFILE: "UserStore/A_GET_USER_PROFILE",
      UPDATE_NAV_MENU_HIDDEN: "appConfig/UPDATE_NAV_MENU_HIDDEN",
    }),
  },
  computed: {
    ...mapState("UserStore", ["S_USER_PROFILE"]),
  },
  created() {
    this.UPDATE_NAV_MENU_HIDDEN(true);
    this.$http.get("/profile/data").then((res) => {
      this.profileData = res.data;
    });
    this.A_GET_USER_PROFILE();
  },
  destroyed() {
    this.UPDATE_NAV_MENU_HIDDEN(false);
  },
};
</script>

<style lang="scss" >
@import "@core/scss/vue/pages/page-profile.scss";
</style>
